import { baseUrl } from "../../../../common/config";
import { http } from "../../../../common/helpers";

export const stripeSession = (profileId) =>
  http.post(`${baseUrl}/api/payment/subscription/portal-session/${profileId}`);
